import React from 'react'
import { connect } from 'react-redux'

class AutoresponseKeyword extends React.Component {
	render() {
		return (
			<div className="col-sm-12 py-4">
				<div className="d-flex">
                    <div className="flex-grow-1 mr-2" id={this.props.autoresponseKeyword.id ?? null}>
                        <h5>{__('Keyword/Phrase')}:</h5>
                        <div className="input-group feedback-form-control border mb-3 mt-3">
                            <input
                                type="text"
                                onChange={this.props.changeKeyword.bind(this)}
                                value={this.props.autoresponseKeyword.keyword}
                                name={`keyword_responses[${this.props.idx}][keyword]`}
                                required
                                className="input form-control"
                                placeholder={' '}
                            />
                        </div>

                        {this.props.autoresponseKeyword.keyword_error &&
                            <label className="text-danger">{this.props.autoresponseKeyword.keyword_error}</label>
                        }


                        <h5>{__('Auto-Response Message')}:</h5>
                        <div className="input-group feedback-form-control border mt-3">
							<textarea
                                onChange={this.props.changeResponse.bind(this)}
                                value={this.props.autoresponseKeyword.response}
                                name={`keyword_responses[${this.props.idx}][response]`}
                                required
                                className="input form-control placeholder-up"
                                placeholder={' '}
                            >

							</textarea>
                        </div>
                        {this.props.autoresponseKeyword.response_error &&
                            <label className="text-danger">{this.props.autoresponseKeyword.response_error}</label>
                        }
                    </div>
                    <div className="d-flex align-items-center mb-4 justify-content-end justify-content-sm-center">
                        <a href="#" className="delete dark-grey-x" onClick={this.props.delete.bind(this)}><i
                            className="fas fa-times text-dark"></i></a>
                    </div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return { state: state }
}

export default connect(mapStateToProps)(AutoresponseKeyword);
